<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <app-breadcrumb class="flex-grow-1" />
      <div class="nav">
        <locale :locales="langs.locales" />
      </div>
      <dark-toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ getUserFullname }}
            </p>
            <span class="user-status">Admin</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="getUserPhoto"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item @click="$router.push({ name: 'profile-view', params: { id: getUserData.id } })" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>{{ $t('navbars.profile') }}</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{ $t('navbars.logout') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import { mapMutations } from 'vuex'
import localeLangs from '@/utils/locales'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    AppBreadcrumb,
    // Navbar Components
    DarkToggler,
    Locale,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // user_data: null,
      langs: localeLangs,
    }
  },
  computed: {
    getUserFullname() {
      const { first_name, username } = useJwt.getUserData()
      const full_name = `${first_name || username}`
      return full_name
    },
    getUserPhoto() {
      const user_data = useJwt.getUserData()
      return user_data?.profile?.photo
    },
    getUserData() {
      return useJwt.getUserData()
    },
  },
  methods: {
    ...mapMutations('users', ['SET_USER_PERMISSIONS']),
    logout() {
      this.SET_USER_PERMISSIONS([])
      useJwt.logout()
    },
  },
}
</script>
